import React, { Component } from 'react'
import { Link } from 'react-router-dom';
import './Style.scss'
import ReactPlayerLoader from '@brightcove/react-player-loader';

const TextAboveImage = ({ articleObj, containerObjectAttr }) => {
    var content = articleObj;

    const handleErrorImageLoading = ({ currentTarget }) => {
        currentTarget.onerror = null; // prevents looping
        currentTarget.src = content.attributes.fallbackImageUrl ? content.attributes.fallbackImageUrl : "";
    }

    return (
        <>
            <div className={`${content.attributes.articleRendering} ${content.attributes.class}`} data-type="TextAboveImage"
                style={content.attributes.articlePadding ? { padding: `${content.attributes.articlePadding}` } : {}}>
                {content.attributes && content.attributes.mainSectionUrl ?
                    <a href={content.attributes.mainSectionUrl}>
                        <div className='card-design'>
                            {content.title ?
                                <p className={`card-text ${content.attributes && content.attributes.titleCss}`} dangerouslySetInnerHTML={{ __html: content.title }}></p>
                                : ""}
                            {content.body ?
                                <div className='card-body' dangerouslySetInnerHTML={{ __html: content.body }}></div>
                                : ""}
                            {content.attributes.mainImageUrl && content.mainImage ?
                                <a target={content.attributes.openLinkInNewTabYn === "true" ? "_blank" : ""}
                                    href={content.attributes.linkUrl? content.attributes.linkUrl:  content.attributes.mainImageUrl}>
                                    <img src={`${content.mainImage ? content.mainImage : ""}`} loading={content && content.attributes && content.attributes.imageFetchPriortityAttr == "lazy" ? "lazy" : content && content.attributes && content.attributes.imageFetchPriortityAttr != "high" && containerObjectAttr && containerObjectAttr.imageFetchPriortityAttr && containerObjectAttr.imageFetchPriortityAttr == "lazy" ? "lazy" : ""} fetchPriority={content && content.attributes && content.attributes.imageFetchPriortityAttr =="high" ? "high" : content && content.attributes && content.attributes.imageFetchPriortityAttr !="lazy" && containerObjectAttr && containerObjectAttr.imageFetchPriortityAttr && containerObjectAttr.imageFetchPriortityAttr == "high" ? "high" : "low"} onError={handleErrorImageLoading} className='img-fluid' alt={content.attributes.altText} />
                                </a>
                                :
                                content.mainImage ?
                                    (content.attributes.linkUrl ?
                                        <a href={content.attributes.linkUrl? content.attributes.linkUrl:  ''} target={content.attributes.openLinkInNewTabYn === "true" ? "_blank" : ""}>
                                            <img src={`${content.mainImage ? content.mainImage : ""}`} className={`img-fluid ${content.attributes.imageRendering}`} alt={content.attributes.altText} />
                                        </a>
                                        : <img src={`${content.mainImage ? content.mainImage : ""}`} className={`img-fluid ${content.attributes.imageRendering}`} alt={content.attributes.altText} />
                                    )
                                    : ""
                            }
                        </div>
                    </a> :
                    <div className='card-design'>
                        {content.title ?
                            <p className={`card-text ${content.attributes && content.attributes.titleCss}`} dangerouslySetInnerHTML={{ __html: content.title }}></p>
                            : ""}
                        {content.body ?
                            <div className='card-body' dangerouslySetInnerHTML={{ __html: content.body }}></div>
                            : ""}
                        {content.attributes.mainImageUrl && content.mainImage ?
                            <a target={content.attributes.openLinkInNewTabYn === "true" ? "_blank" : ""}
                                href={content.attributes.linkUrl? content.attributes.linkUrl:  content.attributes.mainImageUrl}>
                                <img src={`${content.mainImage ? content.mainImage : ""}`} loading={content && content.attributes && content.attributes.imageFetchPriortityAttr == "lazy" ? "lazy" : content && content.attributes && content.attributes.imageFetchPriortityAttr != "high" && containerObjectAttr && containerObjectAttr.imageFetchPriortityAttr && containerObjectAttr.imageFetchPriortityAttr == "lazy" ? "lazy" : ""} fetchPriority={content && content.attributes && content.attributes.imageFetchPriortityAttr =="high" ? "high" : content && content.attributes && content.attributes.imageFetchPriortityAttr !="lazy" && containerObjectAttr && containerObjectAttr.imageFetchPriortityAttr && containerObjectAttr.imageFetchPriortityAttr == "high" ? "high" : "low"} onError={handleErrorImageLoading} className='img-fluid' alt={content.attributes.altText} />
                            </a>
                            :
                            content.mainImage ?
                                (content.attributes.linkUrl ?
                                    <a href={content.attributes.linkUrl? content.attributes.linkUrl:  ''} target={content.attributes.openLinkInNewTabYn === "true" ? "_blank" : ""}>
                                        <img src={`${content.mainImage ? content.mainImage : ""}`} className={`img-fluid ${content.attributes.imageRendering}`} alt={content.attributes.altText} />
                                    </a>
                                    : <img src={`${content.mainImage ? content.mainImage : ""}`} className={`img-fluid ${content.attributes.imageRendering}`} alt={content.attributes.altText} />
                                )
                            : ""
                        }
                    </div>}

                {content.attributes.videoId ?
                    content.attributes.videoType && content.attributes.videoType == "vimeo" ?
                        <iframe src={`https://player.vimeo.com/video/${content.attributes.videoId}`} />
                        :
                        content.attributes.videoType == "brightcove" ?
                            <ReactPlayerLoader
                                id="playlist-player-id"
                                playerId={content.playerId ? content.playerId : ""}
                                accountId={content.accountId ? content.accountId : ""}
                                videoId={content.attributes.videoId}
                                options={{
                                    responsive: true,
                                    autoplay: false,
                                    muted: true
                                }}
                            />
                            : "" : ""}
            </div>
        </>
    )
}

export default TextAboveImage
